import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import './styles/customerdashboard.css';
import reportWebVitals from "./reportWebVitals";

import { lazy, Suspense } from "react";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "bootstrap/dist/css/bootstrap.min.css";
import { ThemeProvider } from "./context/ThemeContext";
import { LoadScript } from "@react-google-maps/api";
import { GOOGLE_MAP_API_KEY } from './utility/Utils';
import ScrollToTop from "./components/ScrollToTop";
// ** Lazy load app
const LazyApp = lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ScrollToTop />
    <Provider store={store}>
      <ThemeProvider>
        <Suspense>
          <LoadScript googleMapsApiKey={GOOGLE_MAP_API_KEY}>
            <LazyApp />
            <Toaster
              position="top-right"
              gutter={10}
              containerStyle={{ top: 68 }}
              toastOptions={{
                duration: 4000,
                className: "amped-toast",
                style: {
                  borderRadius: '14px',
                  padding: '13px 16px',
                  fontSize: '13.5px',
                  fontWeight: '500',
                  maxWidth: '400px',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.13)',
                  fontFamily: 'inherit',
                  lineHeight: '1.5',
                  gap: '10px',
                },
                success: {
                  duration: 3500,
                  iconTheme: { primary: '#16a34a', secondary: '#ffffff' },
                  style: {
                    background: '#f0fdf4',
                    border: '1.5px solid #86efac',
                    color: '#15803d',
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: { primary: '#dc2626', secondary: '#ffffff' },
                  style: {
                    background: '#fff1f2',
                    border: '1.5px solid #fca5a5',
                    color: '#b91c1c',
                  },
                },
                loading: {
                  iconTheme: { primary: '#0047a6', secondary: '#ffffff' },
                  style: {
                    background: '#eff6ff',
                    border: '1.5px solid #93c5fd',
                    color: '#1d4ed8',
                  },
                },
              }}
            />
          </LoadScript>
        </Suspense>
      </ThemeProvider>
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
